(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/onboarding-deposit-amount-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/onboarding-deposit-amount-info.js');
"use strict";


const OnboardingDepositAmountInfo = _ref => {
  let {
    depositAmount
  } = _ref;
  const {
    getOnboardingProductInfo,
    onboardingData
  } = svs.accountservicesReact.deposit.helpers.sharedHelpers;
  if (onboardingData !== null && onboardingData !== void 0 && onboardingData.amount && onboardingData !== null && onboardingData !== void 0 && onboardingData.product && depositAmount < (onboardingData === null || onboardingData === void 0 ? void 0 : onboardingData.amount) && depositAmount > 24) {
    const {
      productInfo,
      productAmountInfo
    } = getOnboardingProductInfo(onboardingData);
    return React.createElement("div", {
      className: "bg-tur-100 u-flex-justify-content-center align-center margin-v-2 u-border-radius-12"
    }, React.createElement("div", {
      className: "withdrawal-info-container padding-1"
    }, React.createElement("p", {
      className: "align-left margin-0"
    }, "Ditt spel p\xE5", ' ', productInfo, ' ', "kostar", ' ', productAmountInfo, ". Din ins\xE4ttning kommer inte r\xE4cka till ditt spel.")));
  }
  return null;
};
svs.accountservicesReact.deposit.depositShared.OnboardingDepositAmountInfo = OnboardingDepositAmountInfo;

 })(window);